import BasicCode from "!!raw-loader!./switches/Basic.tsx";
import LabeledCode from "!!raw-loader!./switches/Labeled.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import Basic from "./switches/Basic";
import Labeled from "./switches/Labeled";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Basic", BasicCode, Basic),
		paneComponent("Labeled", LabeledCode, Labeled),
	];

	return (
		<Pane
			components={components}
			imports='import {Switch} from "designSystem/index";'
			muiApi="switch"
			muiComponent="switches"
			{...props}
		/>
	);
};